import { Box, Grid, Typography } from "@mui/material";
import MoodSelectionImage from "../../assets/mood-selection.png";
import ChooseApproachImage from "../../assets/choose-your-approach.png";
import TargetsImage from "../../assets/targets.png";
import TargetsMobileImage from "../../assets/targets_mobile.png";
import useWindowDimensions from "../../helpers/window";

const TaskPrioritization = ({ scrollToRef }) => {
  const { width } = useWindowDimensions();

  return (
    <Box className="task-prioritization" ref={scrollToRef}>
      <Box className="task-prioritization-container">
        <Box className="task-prioritization_mood-selection">
          <Grid
            container
            className="task-prioritization_mood-selection-inner-container"
          >
            <Grid item xs={12} md={1} />
            <Grid
              item
              xs={12}
              md={6}
              className="home-page_feature-image-container"
            >
              <img
                src={MoodSelectionImage}
                className="home-page_feature-image task-prioritization_mood-selection-image"
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={5}
              className="home-page_feature-text-container"
            >
              <Typography
                variant="h2WhiteNoMargin"
                className="home-page_feature-header"
              >
                Indicate your state of mind
              </Typography>
              <Typography
                variant="body1WhiteNoMargin"
                className="home-page_feature-text"
              >
                Tell Mindstack how you are feeling, so it can recommend tasks
                based on your current mood
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box className="task-prioritization_suggested-tasks">
          <Grid
            container
            className="task-prioritization_suggested-tasks-inner-container"
          >
            <Grid item xs={12} md={1} />
            <Grid
              item
              xs={12}
              md={5}
              className="home-page_feature-text-container"
            >
              <Typography
                variant="h2WhiteNoMargin"
                className="home-page_feature-header"
              >
                Choose your approach
              </Typography>
              <Typography
                variant="body1WhiteNoMargin"
                className="home-page_feature-text"
              >
                Sculpt your day around how you feel. Whether you're energized or
                need a break, Mindstack suggests tasks that fit your mood
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              className="home-page_feature-image-container"
            >
              <img
                src={ChooseApproachImage}
                className="home-page_feature-image task-prioritization_mood-selection-image"
              />
            </Grid>
          </Grid>
        </Box>
        <Box className="task-prioritization_targeted-tasks">
          <Grid
            container
            className="task-prioritization_targeted-tasks-inner-container"
          >
            <Grid item xs={12} className="home-page_feature-text-container">
              <Typography
                variant="h2WhiteNoMargin"
                className="home-page_feature-header"
              >
                Targeted tasks
              </Typography>
              <Typography
                variant="body1WhiteNoMargin"
                className="home-page_feature-text"
              >
                Separate your targeted tasks to keep your mind focused on what
                needs doing first
              </Typography>
            </Grid>
            <Grid item xs={12} className="home-page_feature-image-container">
              <img
                src={width > 768 ? TargetsImage : TargetsMobileImage}
                className="home-page_feature-image"
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default TaskPrioritization;
